export class Util {
  public static MapObject<T, U>(
    obj: { [key: string]: T },
    fn: (a: T) => U,
  ): { [key: string]: U } {
    const result: { [key: string]: U } = {};

    for (const key of Object.keys(obj)) {
      result[key] = fn(obj[key]);
    }

    return result;
  }

  public static FormatDate(d: Date): string {
    return d.toLocaleDateString("en-US", {
      second: "numeric",
      minute: "numeric",
      hour: "numeric",
      day: "numeric",
      month: "short",
    });
  }

  public static AddDays(theDate: Date, days: number): Date {
    return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
  }

  public static AddHours(theDate: Date, hours: number): Date {
    return new Date(theDate.getTime() + hours * 60 * 60 * 1000);
  }

  public static IsDayWithinRange(
    day: Date,
    rangeStart: Date,
    length: number,
  ): boolean {
    day = Util.FloorDate(day);
    rangeStart = Util.FloorDate(rangeStart);

    return (
      day >= rangeStart &&
      day < Util.AddDays(Util.FloorDate(rangeStart), length)
    );
  }

  public static FloorDate(d: Date): Date {
    let result = new Date(d);

    result.setHours(0);
    result.setMinutes(0);
    result.setSeconds(0);
    result.setMilliseconds(0);

    return result;
  }

  public static MapObjectKV<T, U>(
    obj: { [key: string]: T },
    fn: (k: string, V: T) => U,
  ): { [key: string]: U } {
    const result: { [key: string]: U } = {};

    for (const key of Object.keys(obj)) {
      result[key] = fn(key, obj[key]);
    }

    return result;
  }

  public static DaysBetweenDates(date1: Date, date2: Date): number {
    const ONE_DAY = 1000 * 60 * 60 * 24;

    const date1_ms = date1.getTime();
    const date2_ms = date2.getTime();

    const difference_ms = Math.abs(date1_ms - date2_ms);

    return Math.round(difference_ms / ONE_DAY);
  }

  /**
   * Sorts an array by a key, in place.
   */
  public static SortByKey<T>(array: T[], key: (t: T) => number): T[] {
    return array.sort((a, b) => {
      const x = key(a);
      const y = key(b);

      return x < y ? -1 : x > y ? 1 : 0;
    });
  }
}

export function assertNever(x: never): never {
  throw new Error("Unexpected object in assertNever: " + x);
}
